/**
 * Birthday Form - Script
 * Opens modal ONLY when URL contains #birthday-form
 */

(function() {
    'use strict';

    // ============================================
    // CONFIGURATION
    // ============================================
    const CONFIG = {
        googleSheetsURL: 'https://script.google.com/macros/s/AKfycbyPdkEC-ZMVZl9vLzyrIVgyTx4Ie5pINFyEeuZG3SiXAkefKQzvkKLa3K3dfmmi92jj/exec',
        triggerHash: '#birthday-form', // Modal opens ONLY when this hash is in the URL
        sheetName: 'Birthday Returns New', // Sheet tab name in Google Spreadsheet
        thankYouPage: 'https://www.rabitat.com/pages/birthday-submission', // Redirect after form submission
    };

    // ============================================
    // FORM FUNCTIONALITY
    // ============================================
    let elements = {};

    function initForm() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', setupForm);
        } else {
            setupForm();
        }
    }

    function setupForm() {
        elements = {
            form: document.getElementById('rblpBirthdayForm'),
            overlay: document.getElementById('rblpFormOverlay'),
            closeBtn: document.getElementById('rblpCloseBtn'),
            submitBtn: document.getElementById('rblpSubmitBtn'),
            successMessage: document.getElementById('rblpSuccessMessage'),
            successCloseBtn: document.getElementById('rblpSuccessCloseBtn'),
            submitText: document.querySelector('.rblp-submit-text'),
            submitLoader: document.querySelector('.rblp-submit-loader')
        };

        if (!elements.form) {
            return;
        }

        attachFormListeners();
        attachLinkHandlers();
        checkHashOnLoad();

    }

    // ============================================
    // HASH-BASED TRIGGER
    // ============================================

    // Check if page loaded with #birthday-form in URL
    function checkHashOnLoad() {
        if (window.location.hash === CONFIG.triggerHash) {
            openForm();
            // Clean the hash from URL without page reload
            history.replaceState(null, null, window.location.pathname + window.location.search);
        }
    }

    // Listen for hash changes (when user clicks a link with #birthday-form)
    window.addEventListener('hashchange', function() {
        if (window.location.hash === CONFIG.triggerHash) {
            openForm();
            history.replaceState(null, null, window.location.pathname + window.location.search);
        }
    });

    // Intercept clicks on links with href="#birthday-form" to prevent page jump
    function attachLinkHandlers() {
        document.addEventListener('click', function(e) {
            const link = e.target.closest('a');
            if (link && link.getAttribute('href') === CONFIG.triggerHash) {
                e.preventDefault();
                openForm();
            }
        });
    }

    // ============================================
    // FORM LISTENERS
    // ============================================
    function attachFormListeners() {
        elements.form.addEventListener('submit', handleFormSubmit);

        if (elements.closeBtn) {
            elements.closeBtn.addEventListener('click', closeForm);
        }

        if (elements.successCloseBtn) {
            elements.successCloseBtn.addEventListener('click', closeForm);
        }

        if (elements.overlay) {
            elements.overlay.addEventListener('click', function(e) {
                if (e.target === elements.overlay) {
                    closeForm();
                }
            });
        }

        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') {
                closeForm();
            }
        });

        const phoneInput = document.getElementById('rblpPhone');
        if (phoneInput) {
            phoneInput.addEventListener('input', function() {
                this.value = this.value.replace(/[^0-9]/g, '').slice(0, 10);
            });
        }
    }

    async function handleFormSubmit(e) {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        const formData = getFormData();
        setLoadingState(true);

        try {
            if (CONFIG.googleSheetsURL) {
                await submitToGoogleSheets(formData);
            } else {
                await new Promise(resolve => setTimeout(resolve, 1500));
            }

            elements.form.reset();

            // Redirect to Thank You page
            window.location.href = CONFIG.thankYouPage;

        } catch (error) {
            console.error('RBLP Form: Submission error:', error);
            alert('Sorry, there was an error submitting your form. Please try again.');
            setLoadingState(false);
        }
    }

    function validateForm() {
        const name    = document.getElementById('rblpName').value.trim();
        const phone   = document.getElementById('rblpPhone').value.trim();
        const email   = document.getElementById('rblpEmail').value.trim();
        const units   = document.getElementById('rblpUnits').value;
        const inquiry = document.getElementById('rblpInquiry').value;

        if (!name) { alert('Please enter your name'); return false; }
        if (!phone) { alert('Please enter your phone number'); return false; }
        if (phone.length !== 10) { alert('Phone number must be exactly 10 digits'); return false; }
        if (!/^[0-9]{10}$/.test(phone)) { alert('Phone number must contain only digits'); return false; }
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { alert('Please enter a valid email address'); return false; }
        if (!units) { alert('Please select number of units'); return false; }
        if (!inquiry) { alert('Please select inquiry type'); return false; }

        return true;
    }

    function getFormData() {
        return {
            name: document.getElementById('rblpName').value.trim(),
            phone: '+91' + document.getElementById('rblpPhone').value.trim(),
            email: document.getElementById('rblpEmail').value.trim(),
            units: document.getElementById('rblpUnits').value,
            inquiry: document.getElementById('rblpInquiry').value,
            message: document.getElementById('rblpMessage').value.trim(),
            sheetName: CONFIG.sheetName,
            timestamp: new Date().toISOString(),
            source: window.location.href,
            userAgent: navigator.userAgent
        };
    }

    async function submitToGoogleSheets(formData) {
        const response = await fetch(CONFIG.googleSheetsURL, {
            method: 'POST',
            mode: 'no-cors',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        });
        return response;
    }

    function setLoadingState(isLoading) {
        if (elements.submitBtn) elements.submitBtn.disabled = isLoading;
        if (elements.submitText) elements.submitText.style.display = isLoading ? 'none' : 'inline';
        if (elements.submitLoader) elements.submitLoader.style.display = isLoading ? 'flex' : 'none';
    }

    function showSuccessMessage() {
        if (elements.form) elements.form.style.display = 'none';
        if (elements.successMessage) elements.successMessage.style.display = 'block';
    }

    function closeForm() {
        if (elements.overlay) elements.overlay.style.display = 'none';
        setTimeout(() => {
            if (elements.form) { elements.form.style.display = 'flex'; elements.form.reset(); }
            if (elements.successMessage) elements.successMessage.style.display = 'none';
        }, 300);
    }

    function openForm() {
        if (elements.overlay) elements.overlay.style.display = 'flex';
    }

    // ============================================
    // PUBLIC API
    // ============================================
    window.RBLPForm = {
        open: openForm,
        close: closeForm,
        setGoogleSheetsURL: function(url) {
            CONFIG.googleSheetsURL = url;
        },
        setThankYouPage: function(url) {
            CONFIG.thankYouPage = url;
        }
    };

    // Initialize
    initForm();

})();
